import React, { Component } from "react";
import { connect } from "react-redux";

//UI COMPONENT
import {List, ListItem } from "material-ui/List"
import Divider            from 'material-ui/Divider';
import TextField          from "material-ui/TextField";
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table";
//IMPORT COMPONENT
import Menu         from "../Components/component_Menu";
import Loader       from "../Components/component_Loader";
import ErrorMessage from "../Components/component_MsgError";

import ConfirmDialog from "../Components/component_ConfirmDialog";

import IconArrowForward from "material-ui/svg-icons/navigation/arrow-forward";
import IconHome from "material-ui/svg-icons/action/home";
import { LABEL_PasswordChange, LABEL_LanguagedChange, LABEL_SelectLanguage, LABEL_PAGE_Settings, LABEL_PasswordNotEquals, LABEL_Required, LABEL_Save, LABEL_System, LABEL_Cancel, LABEL_User, LABEL_Enter_Password, LABEL_PasswordOld, LABEL_PasswordConfirm, LABEL_Delete, LABEL_PasswordNew  } from "../Utils/Strings/Labels"
import { checkEmail, checkCap, checkNull, checkPivaForm, checkEmailForm, checkCapForm , checkPassword, checkUserLanguage} from "../Utils/Check_Value";
import { changePassword, confirmDialogClose, confirmDialogOpen, getLanguageList, setLanguage } from "../Actions/Action_ServiceRequest_Impostazioni";
import * as ROLES  from "../Utils/Roles_Types.js";
import "../CSS/style_Impostazioni.css"


const USERINFO      = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERLANGUAGE = checkUserLanguage(USERINFO);


class Impostazioni extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialog: {
        function  : 0,
        opened    : false,
        title     : null,
        body      : null,
        onConfirm : null,
        labelConfirm : null,
        labelCancel  : null,
        data      : {},
        onCancel  : () => { this.setState( {dialog: {onCancel : this.state.dialog.onCancel, function: 0}} ); this.props.dispatch(confirmDialogClose())}
      }
    }
  }

  _onDialogTextChange(dataPosition, value){
    var dialog = this.state.dialog;
    dialog.data[dataPosition] = value;
    setTimeout(this.setState({ dialog : dialog }), 3000);
  }

  onClickListItem_ChangePassword = () =>{
    var dialog = this.state.dialog;
    dialog.title  = LABEL_PasswordChange[USERLANGUAGE];
    dialog.labelConfirm = LABEL_Save[USERLANGUAGE];
    dialog.labelCancel  = LABEL_Cancel[USERLANGUAGE];
    dialog.data = {
      oldPassword : "",
      newPassword : "",
      confirmNewPassword : ""
    };
    dialog.function = 1;
    dialog.onConfirm = () => {
      var d = this.state.dialog;
      var data = d.data;
      var flag = true;
      //OLD PASSWORD
      if( checkNull(data.oldPassword) ){
        data.oldPasswordError = LABEL_Required[USERLANGUAGE];
        flag = false;
      }else data.oldPasswordError = null;
      //NEW PASSWORD
      if( checkNull(data.newPassword) ){
        data.newPasswordError = LABEL_Required[USERLANGUAGE];
        flag = false;
      }else data.newPasswordError = null;
      //CONFIRM NEW PASSWORD
      if( checkNull(data.confirmNewPassword) ){
        data.confirmNewPasswordError = LABEL_Required[USERLANGUAGE];
        flag = false;
      }else data.confirmNewPasswordError = null;
      
      if(flag && ( data.newPassword !== data.confirmNewPassword ) ){
        data.confirmNewPasswordError = data.newPasswordError = LABEL_PasswordNotEquals[USERLANGUAGE];
        flag = false;
      }else if(flag) data.confirmNewPasswordError = data.newPasswordError = null;
      
      if(flag){
        data.confirmNewPasswordError = data.newPasswordError = checkPassword(data.newPassword);
        if(data.confirmNewPasswordError != null) flag = false;
      }

      d.data = data;
      if(flag){
        d.opened = false;
        this.props.dispatch(changePassword(d.data));
      }
      this.setState({dialog : d});
    };
    this.props.dispatch(confirmDialogOpen());
    this.setState({dialog : dialog});
  }

  onClickListItem_ChangeLanguage = () => {
    console.log(USERLANGUAGE)
    this.props.dispatch(getLanguageList());
    var dialog = this.state.dialog;
    dialog.title        = LABEL_LanguagedChange[USERLANGUAGE];
    dialog.labelConfirm = LABEL_Save[USERLANGUAGE];
    dialog.labelCancel  = LABEL_Cancel[USERLANGUAGE];
    dialog.data = {
      languageSelected : USERLANGUAGE,
      selectedRow : []
    };
    dialog.function = 2;
    dialog.onConfirm = () => {
      var d = this.state.dialog;
      var data = d.data;
      var flag = true;
      
      if(data.languageSelected == null){
        flag = false;
        data.languageError = LABEL_SelectLanguage[USERLANGUAGE];
        console.log('diasdoiasmdoaswm');
      }else data.languageError = null;

      d.data = data;
      if(flag){
        d.opened = false;
        this.props.dispatch(setLanguage(d.data.languageSelected));
      }
      this.setState({dialog : d});
    };
    dialog.onRowSelection = row   => {
      var value = typeof this.props.languageList[row] === 'undefined' ? null : this.props.languageList[row].Key;
      var dialog = this.state.dialog;
      dialog.data.languageSelected = value;
      dialog.data.selectedRow = row;
      this.setState({ dialog: dialog });
    }
    dialog.isSelectedRow = index => {
      return this.state.dialog.data.languageSelected === this.props.languageList[index].Key; 
    }
    this.setState({dialog : dialog});
  }

  componentDidMount = () =>{
    
  }

  render() {
    
    var dialog = this.state.dialog;
    switch(dialog.function){
      case 1 :
        dialog.body = (
                        <div>
                          <div className="input">
                            <TextField className="input-label"
                              onChange={event => this._onDialogTextChange("oldPassword", event.target.value)}
                              hintText          = {LABEL_Enter_Password[USERLANGUAGE]}
                              floatingLabelText = {LABEL_PasswordOld[USERLANGUAGE]}
                              fullWidth         = {true}
                              type              = "password"
                              errorText         = {this.props.errorOldPassword || this.state.dialog.data.oldPasswordError}
                              value             = {this.state.dialog.data.oldPassword}/>
                          </div>
                          <div className="input">
                            <TextField className="input-label"
                              onChange={event => this._onDialogTextChange("newPassword", event.target.value)}
                              hintText          = {LABEL_Enter_Password[USERLANGUAGE]}
                              floatingLabelText = {LABEL_PasswordNew[USERLANGUAGE]}
                              fullWidth         = {true}
                              type              = "password"
                              errorText         = {this.props.errorNewPassword || this.state.dialog.data.newPasswordError}
                              value             = {this.state.dialog.data.newPassword}/>
                          </div>
                          <div className="input">
                            <TextField className="input-label"
                              onChange={event => this._onDialogTextChange("confirmNewPassword", event.target.value)}
                              hintText          = {LABEL_Enter_Password[USERLANGUAGE]}
                              floatingLabelText = {LABEL_PasswordConfirm[USERLANGUAGE]}
                              type              = "password"
                              fullWidth         = {true}
                              errorText         = {this.props.errorNewPassword || this.state.dialog.data.confirmNewPasswordError}
                              value             = {this.state.dialog.data.confirmNewPassword}/>
                          </div>
                          <div className="input" style={{color : "red", marginTop: "30px", marginBottom: "20px"}}>{this.props.changePasswordError}</div>
                        </div>
                      );
        break;
      case 2 : 
        var error = this.state.dialog.data.languageError;
        dialog.body = (
            <Table
                fixedHeader         = { true  }
                fixedFooter         = { false }
                selectable          = { true  }
                multiSelectable     = { false }
                onRowSelection      = { this.state.dialog.onRowSelection } >
              <TableHeader
                displaySelectAll    = { false }>
                <TableRow>
                  <TableHeaderColumn style={{ color : ! error ? "black" : "red"}}>{"Nome" + (!error ? "" : " ( "+error+" )")}</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody
                deselectOnClickaway = { false }>
                {this.props.languageList !== null && this.props.languageList.map(
                      (row, index) => (
                        <TableRow
                          key={index}
                          selected={this.state.dialog.isSelectedRow(index)}
                        >
                          <TableRowColumn> {row.Name} </TableRowColumn>
                        </TableRow>
                      )
                    )}
              </TableBody>
            </Table>
        )              
        break;
    }
  
  return <div>
        <Menu dispatch={this.props.dispatch} pageName={LABEL_PAGE_Settings[USERLANGUAGE]} Language={USERLANGUAGE}/>
        <ErrorMessage message={this.props.errorMessage} />
        <div className="my-body">
          <div className="imp_label">{LABEL_User[USERLANGUAGE]}</div>
          <List>
            <ListItem onClick={this.onClickListItem_ChangePassword} style={{borderBottom: "1px solid rgb(107, 154, 221)"}}>
              {LABEL_PasswordChange[USERLANGUAGE]}
            </ListItem>
          </List>
          <Divider/>
          <div className="imp_label">{LABEL_System[USERLANGUAGE]}</div>
          <List>
            <ListItem onClick={this.onClickListItem_ChangeLanguage} style={{borderBottom: "1px solid rgb(107, 154, 221)"}}>
              {LABEL_LanguagedChange[USERLANGUAGE]}
            </ListItem>
          </List>
          <Divider/>
        </div>
        
        <ConfirmDialog 
          title        = { this.state.dialog.title               }
          opened       = { this.props.changePasswordDialogOpened }
          confirmLabel = { this.state.dialog.labelConfirm        }
          cancelLabel  = { this.state.dialog.labelCancel         }
          onCancel     = { this.state.dialog.onCancel            }
          body         = { this.state.dialog.body                }
          onConfirm    = { this.state.dialog.onConfirm           } />
      </div>;
  }
}


function mapStateToProps(state) {
  const { impostazioneReducer } = state;
  const { isFetching, isAuthenticated, languageList, errorMessage, changePasswordDialogOpened, changePasswordError, errorOldPassword, errorNewPassword } = impostazioneReducer;
  return {
    isFetching,
    isAuthenticated,
    errorMessage,
    changePasswordDialogOpened,
    changePasswordError,
    errorOldPassword,
    errorNewPassword,
    languageList
  };
}

export default connect(mapStateToProps)(Impostazioni);


// WEBPACK FOOTER //
// ./src/Containers/Impostazioni.js